const Language = {
  setLanguage: function () {
    const languageAll = document.querySelectorAll('[data-language]');

    if (languageAll.length > 0)
      languageAll.forEach((language) => {
        const currentLanguage = language.querySelector('[data-current-language]');
        const hrefLanguage = language.querySelectorAll('[data-language-href]');

        language.addEventListener('click', () => {
          language.classList.toggle('-show');
        });

        if (hrefLanguage.length > 0)
          hrefLanguage.forEach((href) => {
            href.addEventListener('click', () => {
              const value = href.getAttribute('data-language-href');

              localStorage.setItem('language', value);
              this.setLanguageUrl();
            });
          });

        if (window.innerWidth < 768) {
          if (window.location.href.includes('language=pt-BR')) {
            currentLanguage.innerHTML = `<svg class="icon"><use xlink:href="#icon-brasil"></use></svg>`;
          } else if (window.location.href.includes('language=en')) {
            currentLanguage.innerHTML = `<svg class="icon"><<use xlink:href="#icon-eua"></use></svg>`;
          }
        } else {
          if (window.location.href.includes('language=pt-BR')) {
            currentLanguage.innerHTML = `<span>BRASIL</span>`;
          } else if (window.location.href.includes('language=en')) {
            currentLanguage.innerHTML = `<span>EUA</span>`;
          }
        }
      });
  },

  setLanguageUrl: function () {
    const paramsLanguageUrl = localStorage.getItem('language');
    const urlParams = new URLSearchParams(window.location.search);

    urlParams.set('language', paramsLanguageUrl);

    if (window.location.search.includes(`language=${localStorage.getItem('language')}`)) return;
    window.location.search = urlParams;

    if (paramsLanguageUrl) console.log('language =>', paramsLanguageUrl);
  },

  init: function () {
    const _this = this;

    _this.setLanguage();

    if (localStorage.getItem('language')) {
      _this.setLanguageUrl();
    }
  },
};

export default Language;
